import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../queryKeys'
import { auditAiRequest } from '../../util/api/audit-ai-api'
import checkToken from '../../util/auth/checkToken'

export const useAuditHistory = (auditId: string | null) => {
  const queryKey = queryKeys.auditHistory(auditId ?? '')

  const queryResult = useQuery({
    queryKey,
    queryFn: async () => {
      try {
        await checkToken()
        const { results } = await auditAiRequest.dashboard.auditHistory({
          token: '',
          id: auditId ?? '',
        })
        return results
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    enabled: !!auditId,
  })

  return queryResult
}
